import React from 'react';
import Header from "./components/header";
import Home from "./pages/home";
import Footer from './components/footer';
import { HashRouter as AppRouter, Route, Switch } from "react-router-dom";
import Detail from "./pages/details";
import Result from "./pages/result";
import Formulaire from "./pages/formulaire";
import Setting from "./pages/settings";
import Notification from "./pages/notification";
import Profile from "./pages/profile";
import Favorite from "./pages/favorite";
import Ajouter from "./pages/ajouter";
import FormulaireDistance from "./pages/formulaire-distance";
import JobPage from "./pages/job";
import Proche from "./pages/proche";
import PageNotFound from './pages/page_note_found';

function App() {
  return (
    <React.Fragment>
      <AppRouter>

        <Header />
        <main role="main">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/detail/:id" component={Detail} />
            <Route path="/result" component={Result} />
            <Route path="/formulaire" component={Formulaire} />
            <Route path="/formulaire-distance" component={FormulaireDistance} />
            <Route path="/ajouter" component={Ajouter} />
            <Route path="/proche" component={Proche} />
            <Route path="/settings" component={Setting} />
            <Route path="/notification" component={Notification} />
            <Route path="/profile" component={Profile} />
            <Route path="/favorie" component={Favorite} />
            <Route path="/job" component={JobPage} />
            <Route component={PageNotFound} />
          </Switch>
        </main>
      </AppRouter>

      <Footer />

    </React.Fragment>

  );
}

export default App;
